const REGISTRATION_KEY = "midpoint_cv_sw_registered";

export async function registerClientViewServiceWorker(slug, version = "0") {
  if (!slug || !("serviceWorker" in navigator)) {
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register(
      `/client-view-sw.js?slug=${encodeURIComponent(slug)}&v=${encodeURIComponent(String(version))}`,
      { scope: "/" }
    );
    sessionStorage.setItem(REGISTRATION_KEY, slug);
    return registration;
  } catch {
    return null;
  }
}

export function unregisterClientViewServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return Promise.resolve();
  }
  return navigator.serviceWorker.getRegistrations().then((registrations) =>
    Promise.all(registrations.map((registration) => registration.unregister()))
  );
}
